module.exports = __webpack_public_path__ + "static/media/ic_suspend_outlet.a1fdbc24.svg";